import { render, staticRenderFns } from "./PPCMInputCloseIO.vue?vue&type=template&id=0995da22&scoped=true&"
import script from "./PPCMInputCloseIO.vue?vue&type=script&lang=js&"
export * from "./PPCMInputCloseIO.vue?vue&type=script&lang=js&"
import style0 from "../Inspection/PPCMInputInspection.scss?vue&type=style&index=0&id=0995da22&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0995da22",
  null
  
)

export default component.exports